module.exports = __webpack_public_path__ + "static/media/0231_Medium.4ef17052.jpg";